import createSchemaMiddleware from 'structure-validation-schema-middleware'

export default createSchemaMiddleware(
  {
    "properties": {
      "desc": {
        "type": "string"
      },
      "title": {
        "type": "string"
      },
      "organizationId": {
        "type": "string"
      },
      "status": {
        "lowercase": true,
        "type": "string"
      },
      "cmsOptions": {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "attributionRequired": {
            "type": "boolean"
          }
        }
      },
      "hosts": {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "allowed": {
            "type": "array",
            "items": {"type": "string"}
          },
          "preview": {
            "lowercase": true,
            "type": "string"
          },
          "production": {
            "lowercase": true,
            "type": "string"
          },
          "staging": {
            "lowercase": true,
            "type": "string"
          }
        }
      },
      "cdnOptions": {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "cacheKeys": {
            "type": "object"
          },
          "purgeFacebook": {
            "type": "boolean"
          },
          "services": {
            "type": "object",
            "additionalProperties": {
              "lowercase": true
            }
          }
        }
      }
    },
  }
)
